import { Injectable, OnDestroy, signal } from '@angular/core';
import { BehaviorSubject, map, Subject, takeUntil } from 'rxjs';
import { AuthenticatedUser } from '../../../../../core/models/authenticated-user';
import { UserRole } from '../../../../../core/enums/users/role';

@Injectable({
    providedIn: 'root',
})
export class UserStateService implements OnDestroy {
    private readonly destroy$ = new Subject<void>();
    private isMasqueradedSignal = signal(false);

    /**
     * The current authenticated user.
     */
    user$: BehaviorSubject<AuthenticatedUser | null> =
        new BehaviorSubject<AuthenticatedUser | null>(null);

    constructor() {
        this.user$
            .pipe(
                map((user) => (user ? user.isMasqueraded : false)),
                takeUntil(this.destroy$),
            )
            .subscribe((isMasqueraded: boolean) => {
                this.isMasqueradedSignal.set(isMasqueraded);
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * The current masquerade status of the user (as a signal).
     */
    isMasqueraded = this.isMasqueradedSignal.asReadonly();
    isRegistered = (): boolean => this.user$.getValue()?.isRegistered ?? false;
    isApproved = (): boolean => this.user$.getValue()?.isApproved ?? false;
    isMember = (): boolean => this.user$.getValue()?.isMember ?? false;
    getRole = (): UserRole | undefined => this.user$.getValue()?.role;
    getUser = (): AuthenticatedUser | null => this.user$.getValue();
}
